var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bs",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M56.6 26.4H537v480.3H56.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "matrix(1.066 0 0 1.067 -60.4 -28.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M990 506.2H9.4V27.6H990z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M990 370.6H9.4V169.2H990z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08ced6",
    d: "M990 506.2H9.4V346.7H990zm0-319H9.4V27.9H990z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 25.9c2.1 0 392.3 237 392.3 237L7.8 505.3 9 25.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.8c52720557dcdf532579a99b8fd6f412.svg";
export { ForwardRef as ReactComponent };